import FormBasic from './components/FormBasic'

import logo from './assets/prf_logo_color.svg'
import './App.css'

export default function App() {
    return (
        <div className="app-container bg-base flex column align-center full-height full-width">
            <header>
                <h1>
                    <img
                        className="logo"
                        src={logo}
                        alt="Pine Rock Foundation"
                    />
                </h1>
            </header>
            <main className="flex column align-center">
                <section className="description">
                    <p className="dark font-xl green center">
                        2026
                        {/* All applications are due by September 15th, 2026 with distributions
            by November<sup>&dagger;</sup>.*/}
                    </p>
                    <p className="instructions dark green center">
                        All fields are required.
                    </p>
                    <p className="warning-msg">No unsolicited requests.</p>
                </section>

                <section>
                    <FormBasic />
                </section>
            </main>

            <footer>
                <div className="flex column">
                    <span className="disclaimer">
                        <sup>&dagger;</sup> Dates subject to change
                    </span>
                    <span className="disclaimer">
                        Please remember to send acknowledgements immediately
                        after receiving a gift.
                    </span>
                    <span className="copyright">
                        &copy; 2026 Pine Rock Foundation, Inc
                    </span>
                </div>
            </footer>
        </div>
    )
}
